import { render, staticRenderFns } from "./ConfigGeneralComponent.vue?vue&type=template&id=6376005b&scoped=true&"
import script from "./ConfigGeneralComponent.vue?vue&type=script&lang=js&"
export * from "./ConfigGeneralComponent.vue?vue&type=script&lang=js&"
import style0 from "./ConfigGeneralComponent.vue?vue&type=style&index=0&id=6376005b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6376005b",
  null
  
)

export default component.exports